"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumMeasures = void 0;
const convert_measure_1 = require("../convert-measure/convert-measure");
function sumMeasures(...items) {
    if (items.length === 0) {
        throw new RangeError('Cannot determine sum of empty array.');
    }
    let sum = items[0].value;
    const { unit } = items[0];
    for (let i = 1; i < items.length; i++) {
        let measure = items[i];
        if (measure.unit !== unit) {
            if (!convert_measure_1.convertMeasure.canConvert(measure, unit)) {
                throw new TypeError(`Expected measure with unit '${unit}', but got '${measure.unit}'.`);
            }
            measure = (0, convert_measure_1.convertMeasure)(measure, unit);
        }
        if (measure.value != null) {
            if (sum == null) {
                sum = measure.value;
            }
            else {
                sum += measure.value;
            }
        }
    }
    return {
        ...items[0],
        value: sum,
    };
}
exports.sumMeasures = sumMeasures;
